/* @jsx h */
import { defineComponent, h } from "vue";
import { useLocalization } from "@lemmonhq/uikit";

interface BatchActionsProps {
  selectedCount: number;
  totalCount: number;
  onSelectAll: () => void;
  onClearSelection: () => void;
  onAcceptSelected: () => void;
  onDeclineSelected: () => void;
  loading: boolean;
}

export const BatchActions = defineComponent<BatchActionsProps>({
  name: "BatchActions",
  props: [
    "selectedCount",
    "totalCount",
    "onSelectAll",
    "onClearSelection",
    "onAcceptSelected",
    "onDeclineSelected",
    "loading",
  ],
  setup(props) {
    const { t } = useLocalization();

    return () => {
      if (props.selectedCount === 0) return null;

      return (
        <div class="flex items-center gap-2 px-4 py-2 bg-accent/10 border-b border-accent/20 sticky top-0 z-10 rounded-lg mb-3">
          <span class="text-sm font-medium text-accent">
            {props.selectedCount} selected
          </span>
          <button
            class="btn btn-xs btn-ghost"
            onClick={
              props.selectedCount < props.totalCount
                ? props.onSelectAll
                : props.onClearSelection
            }
          >
            {props.selectedCount < props.totalCount ? "Select All" : "Clear"}
          </button>
          <div class="flex-1" />
          <button
            class="btn btn-xs bg-emerald-500 hover:bg-emerald-600 border-0 text-accent gap-1"
            onClick={props.onAcceptSelected}
            disabled={props.loading}
          >
            <span class="material-symbols-outlined text-sm">check</span>
            <span class="hidden sm:inline">Accept Selected</span>
          </button>
          <button
            class="btn btn-xs btn-ghost text-base-content/60 hover:text-error hover:bg-error/10 gap-1"
            onClick={props.onDeclineSelected}
            disabled={props.loading}
          >
            <span class="material-symbols-outlined text-sm">close</span>
            <span class="hidden sm:inline">Decline</span>
          </button>
        </div>
      );
    };
  },
});
